import {
  DispositivoDto,
  getGetDispositivoQueryKey,
  useActionDispositivo,
} from "@/api";
import Button from "@/elements/Button";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { toast } from "react-toastify";
import { SmallLoading } from "../../Loading";
import { DispositivoAction } from "..";

export function StartStopResetButtons({
  dispositivo,
}: {
  dispositivo: DispositivoDto;
}) {
  const [sentAction, setSentAction] = useState<DispositivoAction | null>(null);

  const { mutateAsync: setActionAsync, isLoading: actionLoading } =
    useActionDispositivo();

  const queryClient = useQueryClient();

  async function setAction(action: DispositivoAction) {
    try {
      setSentAction(action);
      const response = await setActionAsync({
        id: dispositivo.id,
        data: { action: action },
      });
      if (response.data?.updated) {
        toast.success("Stato del macchinario cambiato con successo!");
      } else {
        toast.warn(
          "Il cambio di stato è stato inviato al PLC, ma non è stata ricevuta alcuna risposta"
        );
      }
    } catch (e) {
      toast.error("Errore durante il cambiamento di stato del macchinario");
    } finally {
      setSentAction(null);
      queryClient.invalidateQueries({
        queryKey: getGetDispositivoQueryKey(dispositivo.id),
      });
    }
  }

  const powerStatus =
    !!dispositivo.lastStatus &&
    ["on", "on-manuale", "alarm"].includes(dispositivo.lastStatus);

  const manuale =
    dispositivo.lastStatus === "on-manuale" ||
    dispositivo.lastStatus === "off-manuale";

  return (
    <>
      {powerStatus && manuale && (
        <Button
          size="small"
          variant="contained"
          color={actionLoading ? undefined : "light"}
          disabled={actionLoading}
          onClick={() => {
            setAction("stop-manuale").then();
          }}
          startIcon={
            sentAction === "stop-manuale" && <SmallLoading sx={{ mr: 1 }} />
          }
        >
          Stop (manuale)
        </Button>
      )}
      {powerStatus && !manuale && (
        <Button
          size="small"
          variant="contained"
          color={actionLoading ? undefined : "light"}
          disabled={actionLoading}
          onClick={() => {
            setAction("stop").then();
          }}
          startIcon={sentAction === "stop" && <SmallLoading sx={{ mr: 1 }} />}
        >
          Stop
        </Button>
      )}
      {!powerStatus && (
        <Button
          size="small"
          variant="contained"
          color={actionLoading ? undefined : "light"}
          disabled={actionLoading}
          onClick={() => {
            setAction("start").then();
          }}
          startIcon={sentAction === "start" && <SmallLoading sx={{ mr: 1 }} />}
        >
          Start
        </Button>
      )}
      {!powerStatus && (
        <Button
          size="small"
          variant="contained"
          color={actionLoading ? undefined : "light"}
          disabled={actionLoading}
          onClick={() => {
            setAction("start-manuale").then();
          }}
          startIcon={
            sentAction === "start-manuale" && <SmallLoading sx={{ mr: 1 }} />
          }
        >
          Start (manuale)
        </Button>
      )}

      <Button
        size="small"
        variant="contained"
        color={actionLoading ? undefined : "light"}
        disabled={actionLoading}
        onClick={() => {
          setAction("reset").then();
        }}
        startIcon={sentAction === "reset" && <SmallLoading sx={{ mr: 1 }} />}
      >
        Reset
      </Button>
    </>
  );
}
